import { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Dialog, Box, Grid, Button, TextField, Typography, CircularProgress } from '../../../../UI'
import { ChangePasswordPorps } from './types'
import useStyles from './styles'
import { isEmpty, validateEmail } from '../../../../../helpers'
import { authActions } from '../../../../../ducks/actions'
import { logoSmall } from '../../../../../assets'

const ChangePassword: FC<ChangePasswordPorps> = ({ open, setOpen, email = '' }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [emailToSend, setEmailToSend] = useState(email)
  const [loading, setLoading] = useState(false)
  const [sendEmailError, setSendEmailError] = useState(false)
  const [sendEmailSuccess, setSendEmailSuccess] = useState(false)
  const [submit, setSubmit] = useState(false)

  const handleAccept = (): void => {
    setSubmit(true)
    setSendEmailError(false)
    setSendEmailSuccess(false)
    if (validateEmail(emailToSend)) {
      setLoading(true)
      dispatch(authActions.changePasswordRequest({
        email: emailToSend,
        callback: (success: boolean) => {
          setLoading(false)
          if (success) setSendEmailSuccess(true)
          else {
            setSendEmailError(true)
            setSubmit(false)
          }
        }
      }))
    }
  }

  return (
    <Dialog open={open}>
      <Box className={classes.root}>
        <Grid
          container
          alignContent='center'
          direction='column'
          spacing={2}
          className={classes.center}
        >
          <Grid container item xs={12} spacing={1}>
            <Grid item xs={12}>
              <img src={logoSmall} alt='' style={{ width: '50px' }} />
              <Typography variant='h6' color='primary'>
                Need help with your password?
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box style={{ padding: '0 5%' }}>
                <Typography variant='caption'>
                  Enter the email you use for Bosscat, and we'll help you create a new password
                </Typography>
              </Box>
              <TextField
                label='E-mail'
                type='email'
                variant='outlined'
                size='small'
                margin='normal'
                value={emailToSend}
                error={submit && (isEmpty(emailToSend) || !validateEmail(emailToSend))}
                onChange={(event) => { if (!loading) { setEmailToSend(event.target.value) } }}
                fullWidth
              />
              <Box style={{ padding: '0 10%' }}>
                {sendEmailError && (
                  <Typography variant='body2' color='error'>
                    An error occurred, please check you have the right email.
                  </Typography>
                )}
                {sendEmailSuccess && (
                  <Typography variant='body2' color='secondary'>
                    Thank you, instructions to reset have been sent to your email.
                  </Typography>
                )}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant='contained'
                color='primary'
                component='span'
                onClick={() => { if (!loading) handleAccept() }}
                fullWidth
              >
                {loading
                  ? <CircularProgress color='inherit' size={24} />
                  : 'Send Email'}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant='text'
                onClick={() => setOpen(false)}
                fullWidth
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  )
}

export default ChangePassword
